import {INPUT_PARAM_CONSTRAINTS} from "../../components/InputsForm/constants";

const errorMessages = {
	vinMinRequired: 'Vin min 为必填项',
	vinMaxRequired: 'Vin max 为必填项',
	voutRequired: 'Vout 为必填项',
	ioutRequired: 'Iout 为必填项',
	ambientTemperatureRequired: '环境温度 为必填项',
	vinMinNumber: 'Vin min 须是一个有效数值',
	vinMaxNumber: 'Vin max 须是一个有效数值',
	vinNomNumber: 'Vin nom 须是一个有效数值',
	voutNumber: 'Vout 须是一个有效数值',
	ioutNumber: 'Iout 须是一个有效数值',
	ambientTemperatureNumber: '环境温度 须是一个有效数值',
	vinMinInRange:
		'Vin min 必须在范围内 [' + INPUT_PARAM_CONSTRAINTS.VIN_MIN + ',' + INPUT_PARAM_CONSTRAINTS.VIN_MAX + ']',
	vinMaxInRange:
		'Vin max 必须在范围内 [' + INPUT_PARAM_CONSTRAINTS.VIN_MIN + ',' + INPUT_PARAM_CONSTRAINTS.VIN_MAX + ']',
	voutInRange:
		'Vout 必须在范围内 (' + INPUT_PARAM_CONSTRAINTS.VOUT_MIN + ',' + INPUT_PARAM_CONSTRAINTS.VOUT_MAX + ']',
	ioutInRange:
		'Iout 必须在范围内 (' + INPUT_PARAM_CONSTRAINTS.IOUT_MIN + ',' + INPUT_PARAM_CONSTRAINTS.IOUT_MAX + ']',
	ambientTemperatureInRange:
		'环境温度 必须在范围内 [' +
		INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MIN +
		',' +
		INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MAX +
		']',
	vinMinLoOrEqToVinMax: 'Vin min 必须 <= Vin max',
	vinMaxEqOrGrThanVinMin: 'Vin max 必须 >= Vin min',
	vinNomBetweenVinMinAndVinMax: 'Vin nom 必须在此范围 Vin min and Vim max'
};

export default errorMessages;